"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var spacing_1 = require("../systems/spacing");

console.warn('FormGroup is deprecated. Please use <Box mb="3" /> instead.'); // TODO: Deprecate. Replace with box

var FormGroup = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 16px;\n  ", ";\n"], ["\n  margin-bottom: 16px;\n  ", ";\n"])), function (props) {
  return __assign({}, spacing_1.default(props));
});
exports.default = FormGroup;
var templateObject_1;